export const ROUTES = {
  home: "/",
  about: "/About",
  projects: "/Projects",
  products: "/Products",
  productDetail: "/Products/:slug",
  cart: "/cart",
  checkout: "/checkout",
  orderSuccess: "/order-success",
  services: "/Services",
  contact: "/Contact",
  legacyHome: "/NewCafSports",
};

export function productDetailPath(slug) {
  return `${ROUTES.products}/${slug}`;
}
